/**
 * Recorta a área selecionada do Cropper para Blob (PNG).
 * Por quê: react-easy-crop só devolve pixels; o upload precisa de arquivo.
 */
export async function cropImageToBlob(
  imageSrc: string,
  croppedAreaPixels: { x: number; y: number; width: number; height: number },
  mime: string = "image/png"
): Promise<Blob> {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement("canvas");
  const w = Math.max(1, Math.round(croppedAreaPixels.width));
  const h = Math.max(1, Math.round(croppedAreaPixels.height));
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("canvas_unavailable");
  }
  ctx.drawImage(
    image,
    croppedAreaPixels.x,
    croppedAreaPixels.y,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
    0,
    0,
    w,
    h
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("crop_failed"));
          return;
        }
        resolve(blob);
      },
      mime,
      0.92
    );
  });
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener("load", () => resolve(img));
    img.addEventListener("error", () => reject(new Error("image_load_failed")));
    img.src = src;
  });
}
